import { SharedModule } from 'json-dynamic-form';
import { PinColumnComponent } from './../directives/pin-column/pin-column.component';
import { PlatformModule } from '@angular/cdk/platform';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  MatMultiSort,
  MatMultiSortHeaderComponent,
  MatMultiSortModule,
} from 'ngx-mat-multi-sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTreeModule } from '@angular/material/tree';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from '@angular/material/core';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { CUSTOM_DATE_FORMATS } from '@core/constants/app-constants';

/** Standalone APIs must be re-exported; MatMultiSortModule does not export them to importers. */
const NGX_MAT_MULTI_SORT = [
  MatMultiSortModule,
  MatMultiSort,
  MatMultiSortHeaderComponent,
];

const MATERIAL_MODULES = [
  MatSidenavModule,
  MatListModule,
  MatTabsModule,
  MatTableModule,
  MatCheckboxModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  ...NGX_MAT_MULTI_SORT,
  MatIconModule,
  MatPaginatorModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatInputModule,
  MatTreeModule,
  MatProgressBarModule,
  MatExpansionModule,
  MatDatepickerModule,
  MatTooltipModule,
  MatNativeDateModule,
  MatMomentDateModule,
  OverlayModule,
];

@NgModule({
  declarations: [PinColumnComponent],
  imports: [CommonModule, PlatformModule, ...MATERIAL_MODULES, SharedModule],
  exports: [
    ...MATERIAL_MODULES,
    PlatformModule,
    PinColumnComponent,
    SharedModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
  ],
})
export class AngularMaterialModule {}
